import firebase from 'firebase'

const firebaseConfig = {
    apiKey: "AIzaSyCoI49suRDNV1kax2o55z_c9wBycp1Pops",
    authDomain: "photosharemap.firebaseapp.com",
    projectId: "photosharemap",
    storageBucket: "photosharemap.appspot.com",
    messagingSenderId: "810224861943",
    appId: "1:810224861943:web:0ab427a8c744eb3d8b89f2",
    measurementId: "G-QQ783EBX01"
}
firebase.initializeApp(firebaseConfig)

export default firebase
